export default function makeAddress(address, city, state, zipCode) {
  return [address, city, state, zipCode].join(", ");
}
